import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import useNavigate from 'Hooks/useNavigate';

import { getNavigateInfo } from 'Store/routing/selectors';

const useRouteNavigate = () => {
  const navigateInfo = useSelector(getNavigateInfo);
  const navigate = useNavigate();
  const { path, state } = navigateInfo || {};

  useEffect(() => {
    if (path) {
      navigate(path, state);
    }
  }, [path, state, navigate]);
};

export default useRouteNavigate;
